import { Stack, StackProps, styled } from "@mui/material";

export const MainBox = styled(Stack)<StackProps>(({ theme }) => ({
  flexGrow: 1,
  width: "42rem",
  [theme.breakpoints.down("lg")]: {
    width: "100%"
  }
}));
